import { env } from '@/lib/runtime-env'

export type PlusPlan = 'monthly' | 'annual'

const MonthlyPlanSku = 'NPP-4dd7ac6c-132c-4776-98e6-004afbdcbee7'

const DEFAULT_MARKET_SERVER = 'https://market.viverse.com'

const DEFAULT_VIVERSE_PLUS_CHECKOUT_URL = `${DEFAULT_MARKET_SERVER}/checkout?source=fromBuyNow&productStandardId=${MonthlyPlanSku}`

const VIVERSE_PLUS_SKU_ENV_KEY_BY_PLAN: Record<PlusPlan, string> = {
  monthly: 'NEXT_PUBLIC_VIVERSE_PLUS_MONTHLY_SKU',
  annual: 'NEXT_PUBLIC_VIVERSE_PLUS_ANNUAL_SKU',
}

export function getViversePlusManageSubscriptionUrl() {
  const marketServer = env('NEXT_PUBLIC_MARKET_SERVER') || DEFAULT_MARKET_SERVER
  return new URL('/subscriptions', marketServer).href
}

export function useViversePlusCheckoutUrl(plan: PlusPlan = 'monthly') {
  const marketServer = env('NEXT_PUBLIC_MARKET_SERVER')
  const sku = env(VIVERSE_PLUS_SKU_ENV_KEY_BY_PLAN[plan]) ?? MonthlyPlanSku

  if (!marketServer || !sku) {
    return DEFAULT_VIVERSE_PLUS_CHECKOUT_URL
  }

  const checkoutUrl = new URL('/checkout', marketServer)
  checkoutUrl.searchParams.set('source', 'fromBuyNow')
  checkoutUrl.searchParams.set('productStandardId', sku)

  return checkoutUrl.href
}
